export const reservationDrawer = {
  title: "Detalhes da reserva",
  openFullPage: "Abrir em página inteira",
  close: "Fechar",
};
